import { FILTER_CHANGE } from '../constants'

const filterChange = (filterType, values, additionalValues, dispatch) => {
  dispatch({ type: FILTER_CHANGE, filterType, values, additionalValues })
  return true
}

export default (filterType, values, additionalValues) => dispatch => filterChange(filterType, values, additionalValues, dispatch)
